import React from "react";
import { Container } from "react-bootstrap";
import {
  FaFacebookF,
  FaTwitter,
  FaPhoneAlt,
  FaEnvelope,
  FaGlobe,
} from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import "bootstrap/dist/css/bootstrap.min.css";
import "./topheader.css";

const TopHeader = () => {
  return (
    <div className="top-header bg-dark py-2 border-bottom">
      <Container>
        <div className="d-flex justify-content-between align-items-center flex-wrap text-white">
          <div className="d-flex align-items-center gap-3 flex-wrap justify-content-between">
            <div className="d-flex align-items-center gap-4 me-5">
              <a href="https://facebook.com" className="text-white">
                <FaFacebookF />
              </a>
              <a href="https://twitter.com" className="text-white">
                <FaTwitter />
              </a>
              <a href="mailto:info@example.com" className="text-white">
                <MdEmail />
              </a>
            </div>
            <div className="d-flex align-items-center gap-2">
              <FaPhoneAlt />
              <span className="small-text">+91-903-333-5354</span>
            </div>
            <div className="d-flex align-items-center gap-2">
              <FaEnvelope />
              <span className="small-text">info@ehsas.life</span>
            </div>
            <div className="d-flex align-items-center gap-2 ">
              <FaGlobe />
              <a href="https://www.ehsas.life" className="small-text">
                www.ehsas.life
              </a>
            </div>
          </div>
          <div className="small-text d-none d-lg-block">
            We Provide High Quality & Cost Effective Services
          </div>
        </div>
      </Container>
    </div>
  );
};

export default TopHeader;
